import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleDoubleUp,
  faChevronRight,
  faExternalLinkAlt,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faAngleDoubleUp,
  faChevronRight,
  faExternalLinkAlt,
  faTimes
)

export default FontAwesomeIcon
